import {
  ExpandMore as ExpandMoreIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";
import assureService from "../../services/assureService";
import ReceptionModal from "./ReceptionModal.jsx";
const formatDate = (dateString) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(dateString).toLocaleDateString("fr-FR", options);
};

const IdentificationAssure = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [assure, setAssure] = useState(null);
  const [openReceptionModal, setOpenReceptionModal] = useState(false);
  const [selectedPolice, setSelectedPolice] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) {
      toast.warning("Veuillez entrer un matricule");
      return;
    }

    setLoading(true);
    try {
      const response = await assureService.getAssureByMatricule(searchTerm);
      if (response.success && response.data) {
        setAssure(response.data);
      } else {
        toast.error("Assuré non trouvé");
        setAssure(null);
      }
    } catch (error) {
      console.error("Erreur:", error);
      toast.error("Erreur lors de la recherche");
      setAssure(null);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString("fr-FR", options);
  };
  return (
    <Box sx={{ p: 3, maxWidth: 1280, margin: "auto" }}>
      <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 4 }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontWeight: "bold",
            color: "primary.main",
            mb: 4,
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <SearchIcon fontSize="large" />
          Vérification de l'Identité des Assurés
        </Typography>

        <form onSubmit={handleSearch}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              mb: 3,
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <TextField
              fullWidth
              label="Recherche par matricule"
              variant="outlined"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              disabled={loading}
              InputProps={{
                sx: { borderRadius: 2 },
                placeholder: "Ex: MAT-123456",
              }}
            />
            <Button
              type="submit"
              variant="contained"
              startIcon={!loading && <SearchIcon />}
              disabled={loading}
              sx={{
                borderRadius: 2,
                px: 4,
                minWidth: 140,
                height: 56,
              }}
            >
              {loading ? <CircularProgress size={24} /> : "Rechercher"}
            </Button>
          </Box>
        </form>

        {assure && (
          <Grid container spacing={3}>
            {/* Informations de l'assuré */}
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  boxShadow: 3,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        color: "text.secondary",
                      }}
                    >
                      Dossier Assuré
                    </Typography>
                    <Divider />

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setOpenReceptionModal(true)}
                      sx={{
                        borderRadius: 2,
                        py: 1.5,
                        textTransform: "none",
                        fontWeight: "bold",
                      }}
                    >
                      Réceptionner
                    </Button>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      mt: 3,
                    }}
                  >
                    <InfoItem label="Matricule" value={assure.matricule} />
                    <InfoItem label="Nom complet" value={assure.fullName} />
                    <InfoItem
                      label="Date de naissance"
                      value={formatDate(assure.date_naissance)}
                    />
                    <InfoItem label="CNI" value={assure.cni} />
                    <InfoItem label="Téléphone" value={assure.tel} />
                    <InfoItem label="Email" value={assure.email} />
                    <InfoItem label="Adresse" value={assure.adresse} />
                    {assure.structure_intitule && (
                      <InfoItem
                        label="Structure"
                        value={assure.structure_intitule}
                      />
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            {/* Contrats d'assurance */}
            <Grid item xs={12} md={8}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                {assure.polices && assure.polices.length > 0 ? (
                  assure.polices.map((contrat, index) => (
                    <PolicyCard
                      key={index}
                      police={contrat}
                      onReceptionner={() => {
                        setSelectedPolice(contrat);
                        setOpenReceptionModal(true);
                      }}
                    />
                  ))
                ) : (
                  <Card
                    sx={{
                      borderRadius: 3,
                      boxShadow: 3,
                      p: 4,
                      textAlign: "center",
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        sx={{ mb: 2 }}
                      >
                        Aucun contrat d'assurance trouvé pour cet assuré.
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        disabled
                        sx={{
                          borderRadius: 2,
                          py: 1.5,
                          textTransform: "none",
                          fontWeight: "bold",
                          mt: 2,
                          opacity: 0.7,
                        }}
                      >
                        Réceptionner
                      </Button>
                    </CardContent>
                  </Card>
                )}
              </Box>
            </Grid>
          </Grid>
        )}
      </Paper>

      <ReceptionModal
        open={openReceptionModal}
        onClose={() => setOpenReceptionModal(false)}
        assure={assure}
        police={selectedPolice}
      />
    </Box>
  );
};

// Sous-composants pour améliorer la lisibilité
const InfoItem = ({ label, value }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
    <Typography
      variant="body2"
      sx={{ fontWeight: "medium", color: "text.secondary" }}
    >
      {label}
    </Typography>
    <Typography variant="body2" sx={{ maxWidth: "60%", textAlign: "right" }}>
      {value || "Non renseigné"}
    </Typography>
  </Box>
);

const PolicyCard = ({ police, onReceptionner }) => (
  <Card
    sx={{
      borderRadius: 3,
      boxShadow: 3,
      position: "relative",
      overflow: "visible",
    }}
  >
    <CardContent>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {/* En-tête */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "primary.main",
            }}
          >
            Police d'Assurance : {police.label}
          </Typography>
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Chip
              label={`N° ${police.numero}`}
              color="primary"
              variant="outlined"
              sx={{ fontWeight: "medium" }}
            />
            <Button
              variant="contained"
              color="success"
              onClick={onReceptionner}
              sx={{
                borderRadius: 2,
                py: 1,
                px: 3,
                ml: 2,
                fontWeight: "bold",
                boxShadow: 2,
                textTransform: "none",
                transition: "background 0.2s, box-shadow 0.2s",
                "&:hover": {
                  backgroundColor: "success.dark",
                  boxShadow: 4,
                },
              }}
            >
              Réceptionner
            </Button>
          </Box>
        </Box>

        <Divider />

        {/* Détails du contrat d'assurance */}
        {police.contrat_assurance && (
          <Box
            sx={{
              bgcolor: "background.paper",
              p: 2,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
              Informations du Contrat
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Date de début:
                    </Typography>
                    <Typography variant="body2">
                      {formatDate(police.contrat_assurance.date_debut)}
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Date de fin:
                    </Typography>
                    <Typography variant="body2">
                      {formatDate(police.contrat_assurance.date_fin)}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Montant de la prime:
                    </Typography>
                    <Typography variant="body2">
                      {Number(police.contrat_assurance.montant).toLocaleString(
                        "fr-FR"
                      )}{" "}
                      FCFA
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      État du contrat:
                    </Typography>
                    <Chip
                      label={
                        police.contrat_assurance.statut ? "Actif" : "Inactif"
                      }
                      color={
                        police.contrat_assurance.statut ? "success" : "error"
                      }
                      size="small"
                      variant="outlined"
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}

        <Typography variant="body2" color="text.secondary">
          {police.description}
        </Typography>

        {/* Section des modules */}
        <Box sx={{ mt: 3 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "text.secondary",
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 2,
            }}
          >
            Modules Actifs
            <Chip
              label={`${police.modules?.length || 0} modules`}
              size="small"
              color="primary"
            />
          </Typography>

          <Box sx={{ mt: 1 }}>
            {police.modules?.map((module, modIndex) => (
              <ModuleAccordion key={modIndex} module={module} />
            ))}
          </Box>
        </Box>
      </Box>
    </CardContent>
  </Card>
);

const ModuleAccordion = ({ module }) => (
  <Accordion sx={{ mb: 2, borderRadius: 2, overflow: "hidden" }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          width: "100%",
          py: 1,
        }}
      >
        <Typography sx={{ flexGrow: 1, fontWeight: "medium" }}>
          {module.label}
        </Typography>
        <Chip
          label={module.statut ? "Actif" : "Inactif"}
          color={module.statut ? "success" : "error"}
          size="small"
          variant="outlined"
        />
      </Box>
    </AccordionSummary>

    <AccordionDetails sx={{ pt: 2, bgcolor: "background.paper" }}>
      <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
        {module.description}
      </Typography>

      {Object.entries(module.content).map(([contentKey, contentValue]) => (
        <Box key={contentKey} sx={{ mt: 2 }}>
          {Array.isArray(contentValue.items) ? (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  {contentValue.label}
                </Typography>
                {contentValue.description && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1 }}
                  >
                    {contentValue.description}
                  </Typography>
                )}
              </Grid>

              {contentValue.items.map((item, itemIndex) => (
                <Grid item xs={12} sm={6} key={itemIndex}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      height: "100%",
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                        {item.name}
                      </Typography>
                      {item.taux && (
                        <Chip
                          label={`Taux: ${item.taux}`}
                          color="info"
                          size="small"
                          sx={{ fontWeight: "bold" }}
                        />
                      )}
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                      {item.description}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Paper
              elevation={0}
              sx={{
                p: 2,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                {contentValue.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {contentValue.description}
              </Typography>
            </Paper>
          )}
        </Box>
      ))}
    </AccordionDetails>
  </Accordion>
);

export default IdentificationAssure;
